import { AnalyticsEvent, AnalyticsEventCategories } from '@/utils/analyticsEvents/categories';

export class TaskStatusReportedEvent extends AnalyticsEvent {
  public readonly identification = AnalyticsEventCategories.TASK_STATUS_REPORTED;

  public constructor(public properties: { done: boolean }) {
    super();
  }
}
